"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var QueriesStore_1 = require("stores/QueriesStore");
var dayjs_1 = __importDefault(require("dayjs"));
var IPCRowInput_1 = __importStar(require("./IPCRowInput"));
var delete_svg_1 = __importDefault(require("res/img/delete.svg"));
var edit_svg_1 = __importDefault(require("res/img/edit.svg"));
var warning_svg_1 = __importDefault(require("res/img/warning.svg"));
var getCurrency = function (country) {
    return country === QueriesStore_1.Countries.IR ? "€" : "£";
};
var IPCTable = function (_a) {
    var type = _a.type, editable = _a.editable, queries = _a.queries, queryAction = _a.queryAction, data = _a.data, deleteRow = _a.deleteRow, editRow = _a.editRow, rowDeleteID = _a.rowDeleteID, rowEditID = _a.rowEditID, addRow = _a.addRow, saveRow = _a.saveRow, busy = _a.busy, country = _a.country;
    var tableBodyRef = react_1.useRef(null);
    react_1.useEffect(function () {
        if (rowDeleteID === null)
            return;
        var deletedChild = null;
        for (var i = 0; i < data.length; i++) {
            if (data[i].id === rowDeleteID) {
                tableBodyRef.current.children[i].setAttribute("data-deleted", "true");
                deletedChild = i;
            }
            if (deletedChild === null)
                continue;
            if (i > deletedChild) {
                tableBodyRef.current.children[i].setAttribute("data-move-up", "true");
            }
        }
        var timer = setTimeout(function () {
            for (var i = 0; i < tableBodyRef.current.children.length; i++) {
                tableBodyRef.current.children[i].setAttribute("data-move-up", "false");
            }
        }, 400);
        return function () { return clearTimeout(timer); };
    }, [rowDeleteID]);
    var getDuplicateLogNo = function (id) {
        for (var _i = 0, queries_1 = queries; _i < queries_1.length; _i++) {
            var query = queries_1[_i];
            if (query.id === id) {
                return query.logNumber;
            }
        }
    };
    return (react_1.default.createElement("div", { className: "ipc-table" },
        react_1.default.createElement("div", { className: "ipc-table__head" },
            react_1.default.createElement("div", { className: "ipc-table__row flex flex-row" },
                queryAction === QueriesStore_1.QueryActions.CREDIT_DEBIT &&
                    react_1.default.createElement("div", { className: "ipc-table__col" }, "A/C No"),
                react_1.default.createElement("div", { className: "ipc-table__col" }, "Bill Ref"),
                react_1.default.createElement("div", { className: "ipc-table__col" }, "Invoice Number"),
                type !== QueriesStore_1.QueryTypes.FLEET &&
                    react_1.default.createElement("div", { className: "ipc-table__col mid-small" }, "Order No"),
                react_1.default.createElement("div", { className: "ipc-table__col mid-small" }, "Invoice Date"),
                react_1.default.createElement("div", { className: "ipc-table__col small" }, "IPC"),
                type === QueriesStore_1.QueryTypes.FLEET &&
                    react_1.default.createElement("div", { className: "ipc-table__col" }, "Worksheet No"),
                type === QueriesStore_1.QueryTypes.FLEET &&
                    react_1.default.createElement("div", { className: "ipc-table__col" }, "PO No"),
                type === QueriesStore_1.QueryTypes.FLEET &&
                    react_1.default.createElement("div", { className: "ipc-table__col small" }, "Tax Code"),
                react_1.default.createElement("div", { className: "ipc-table__col small" }, "QTY"),
                react_1.default.createElement("div", { className: "ipc-table__col small" }, queryAction === QueriesStore_1.QueryActions.CREDIT_DEBIT && "Credit Value" || "Item Net"),
                react_1.default.createElement("div", { className: "ipc-table__col small" }, queryAction === QueriesStore_1.QueryActions.CREDIT_DEBIT && "Debit Value" || "New Net"),
                react_1.default.createElement("div", { className: "ipc-table__col mid-mid-small" }, "Item DR/CR Value"),
                react_1.default.createElement("div", { className: "ipc-table__col mid-mid-small" }, "Total DR/CR Value"))),
        react_1.default.createElement("div", { className: "ipc-table__body", ref: tableBodyRef }, data.map(function (item) { return rowEditID !== item.id ? (react_1.default.createElement("div", { className: "ipc-table__row flex flex-row", key: item.id },
            queryAction === QueriesStore_1.QueryActions.CREDIT_DEBIT &&
                react_1.default.createElement("div", { className: "ipc-table__col" }, item.acNumber),
            react_1.default.createElement("div", { className: "ipc-table__col billRef flex flex-row" },
                editable &&
                    react_1.default.createElement("button", { type: "button", title: "Delete Row", onClick: function () { deleteRow(item.id); } },
                        react_1.default.createElement("img", { src: delete_svg_1.default, alt: "Delete" })),
                editable &&
                    react_1.default.createElement("button", { type: "button", title: "Edit Row", onClick: function () { editRow(item.id); } },
                        react_1.default.createElement("img", { src: edit_svg_1.default, alt: "Edit" })),
                item.billRef,
                item.duplicateBillRef === true &&
                    react_1.default.createElement("div", { className: "duplicate-warning" },
                        react_1.default.createElement("img", { src: warning_svg_1.default, alt: "Warning" }),
                        react_1.default.createElement("div", { className: "text" },
                            react_1.default.createElement("p", null,
                                "A query with this billing reference already exists with the log number: ",
                                react_1.default.createElement("b", null, getDuplicateLogNo(item.duplicateBillRefQueryId)))))),
            react_1.default.createElement("div", { className: "ipc-table__col" },
                item.invoiceNumber,
                " "),
            type !== QueriesStore_1.QueryTypes.FLEET &&
                react_1.default.createElement("div", { className: "ipc-table__col mid-small" }, item.orderNo),
            react_1.default.createElement("div", { className: "ipc-table__col mid-small" }, dayjs_1.default(item.invoiceDate).format("DD/MM/YYYY")),
            react_1.default.createElement("div", { className: "ipc-table__col small" }, item.ipcNumber),
            type === QueriesStore_1.QueryTypes.FLEET &&
                react_1.default.createElement("div", { className: "ipc-table__col" }, item.deliveryNumber),
            type === QueriesStore_1.QueryTypes.FLEET &&
                react_1.default.createElement("div", { className: "ipc-table__col" }, item.poNumber),
            type === QueriesStore_1.QueryTypes.FLEET &&
                react_1.default.createElement("div", { className: "ipc-table__col small" }, item.taxCode),
            react_1.default.createElement("div", { className: "ipc-table__col small" }, item.quantity),
            react_1.default.createElement("div", { className: "ipc-table__col small" }, item.itemNet),
            react_1.default.createElement("div", { className: "ipc-table__col small" }, item.newNet),
            react_1.default.createElement("div", { className: "ipc-table__col mid-mid-small" }, (item.newNet - item.itemNet).toFixed(2)),
            react_1.default.createElement("div", { className: "ipc-table__col mid-mid-small" }, (item.newNet * item.quantity - item.itemNet * item.quantity).toFixed(2))))
            : (react_1.default.createElement(IPCRowInput_1.default, { queryType: type, type: IPCRowInput_1.InputTypes.EDIT, queryAction: queryAction, onSubmit: saveRow, busy: busy, currentData: item })); })),
        editable &&
            react_1.default.createElement(IPCRowInput_1.default, { queryType: type, queryAction: queryAction, onSubmit: addRow, busy: busy })));
};
exports.default = IPCTable;
